import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../types/routes.enum';

export const useModalActions = (chargerName: string) => {
  const navigate = useNavigate();
  const showLogin = () => {
    navigate(`/app/${window.domainName}/login?charger=${chargerName}`);
  };

  const showRegister = () => {
    navigate(`/app/${window.domainName}/register?charger=${chargerName}`);
  };

  const handleIconClicked = () => {
    navigate(`/app/${window.domainName}/${ROUTES.ACCOUNT}?charger=${chargerName}`);
  };

  const handleZendeskChatClicked = () => {
    navigate(`/app/${window.domainName}/${ROUTES.CHAT}?charger=${chargerName}`);
  };

  return { showLogin, showRegister, handleIconClicked, handleZendeskChatClicked };
};
